import React from "react";

import TopSection from "../../component/CorporateGifting/TopSection";
import GifitingDetails from "../../component/CorporateGifting/GiftingDetails/index";
import CommendationCarousel from "../../component/CorporateGifting/CommendationCarousel";
import GiftingEnquiry from "../../component/CorporateGifting/GiftingEnquiry";
import RemarksForm from "../../component/CorporateGifting/RemarksForm";

const CorporateGifting = () => (
  <div>
    <RemarksForm
      containerclassName="nw-mobile-only"
      formclassName="nw-mobile-only"
    />
    <TopSection />
    <GifitingDetails />
    <CommendationCarousel />
    <GiftingEnquiry/>
  </div>
);

export default CorporateGifting;
